import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFormattedDateString, getFormattedDateDDMMYYYY, getAPIHeaders } from '../../../../common/Utils'
import CommonSelectV2 from "../../../../core/common/commonSelectV2";
import FormFooter from "../../../../core/common/formFooter";
import AddMembersForm from "./addMembersForm";
import useFetch from "../../../../hooks/useFetch";
import { API } from "../../../../common/Constants";
import PreLoader from "../../../../core/common/preLoader";
interface Props {
    refresh: () => void
    data?: any
    courseOptions: any[]
    subjectOptions: any[]
    syllabusOptions: any[]
}

const AcademicNodeDataModal = ({ refresh, data, courseOptions, subjectOptions, syllabusOptions }: Props) => {

    const [modalData, setModalData] = useState<any>(data)
 
    const {isLoading, callFetch } = useFetch();

    useEffect(() => {
        setModalData(data)
    }, [data])


    const renderHeader = () => (
        <>
            <div>
                <h4 className="mb-1 text-white">{modalData?.nodeType}</h4>
            </div>
            <div className="d-flex align-items-center">
                <Link
                    to="#"
                    className="custom-btn-close d-flex align-items-center justify-content-center text-white"
                    data-bs-dismiss="offcanvas"
                >
                    <i className="ti ti-x" />
                </Link>
            </div>
        </>
    )

    const renderFooter = () => (
        <>
            <div className="d-flex align-items-center m-2">
                <button

                    className="btn btn-lg custom-btn-close d-flex align-items-center justify-content-center text-white"
                    data-bs-dismiss="offcanvas"
                >
                    <i className="ti ti-x" />
                </button>
            </div>
        </>
    )

    const renderBasiInfo = () => (
        <>
            <h4 className="mb-3">Audit Info</h4>
            <div className="file-type p-2 pb-0 gx-2 mb-2">
                <div className="text-center mb-2 border-end me-2">
                    <p className="fs-12 mb-0">Created By</p>
                    <p className="text-title">{modalData?.createdBy ? modalData?.createdBy : '---'}</p>
                </div>
                <div className="text-center mb-2 me-2 pe-2">
                    <p className="fs-12 mb-0">Created on</p>
                    <p className="text-title text-nowrap">{modalData?.createdOn ? getFormattedDateString(modalData?.createdOn) : '---'}</p>
                </div>
            </div>
            <div className="file-type p-2 pb-0 gx-2 mb-2">
                <div className="text-center mb-2 border-end me-2">
                    <p className="fs-12 mb-0">Updated By</p>
                    <p className="text-title">{modalData?.updatedBy ? modalData?.updatedBy : '---'}</p>
                </div>
                <div className="text-center mb-2  me-2 pe-2">
                    <p className="fs-12 mb-0">Updated on</p>
                    <p className="text-title text-nowrap">{modalData?.updatedOn ? getFormattedDateString(modalData?.updatedOn) : '---'}</p>
                </div>
            </div>
        </>
    )

    const renderMembersInfo = () => {
        return (
            <div className="mt-4">
                {
                    modalData?.nodeType === 'CURRICULUM'
                        ?
                        <>{renderCurriculumMembersForm()}</>
                        :
                        modalData?.nodeType === 'COURSE'
                        ?
                        <>{renderCourseMemberForm()}</>
                        :
                        <>{renderSubjectMemberForm()}</> 
                }
            </div>
        )
    }

    const renderCurriculumMembersForm = () => {
        
        return (
            <AddMembersForm 
                code={modalData?.code}
                heading="Courses"
                formHeading="Select Course To Add In Curriculum"
                data={modalData?.courses}
                options={courseOptions}
                refresh={refresh}
                type={modalData?.nodeType}
                editable={modalData?.live === 'ACTIVE'}
            />
        )
    }

    const renderCourseMemberForm = () => {
        
        return (
            <AddMembersForm 
                code={modalData?.code}
                heading="Subjects"
                formHeading="Select Subject To Add In Course"
                data={modalData?.subjects}
                options={subjectOptions}
                refresh={refresh}
                type={modalData?.nodeType}
                editable={modalData?.live === 'ACTIVE'}
            />
        )

    }

    const renderSubjectMemberForm = () => {
        return (
            <AddMembersForm 
                code={modalData?.code}
                heading="Syllabus"
                formHeading="Select Syllabus for Subject"
                data={modalData?.syllabus}
                options={syllabusOptions}
                refresh={refresh}
                type={modalData?.nodeType}
                editable={modalData?.live === 'ACTIVE'}
            />
        )
    }


    return (
        <>
            <PreLoader showLoader={isLoading} />
            {/* Preview */}
            <div className="sidebar-themesettings offcanvas offcanvas-end" id="node_modal">
                <div className="offcanvas-header d-flex align-items-center justify-content-between bg-dark">
                    {renderHeader()}
                </div>
                <div className="offcanvas-body p-0">
                    <div className="bg-light document-wrap text-center">
                        <h4 className="mb-1">
                            {modalData?.title}
                            <span className="badge badge-secondary-transparent fw-normal fs-12 ms-2">
                                {modalData?.code}
                            </span>
                        </h4>
                        <p className="flex-column d-flex">
                            {modalData?.description}
                            {
                                modalData?.startDate && modalData?.endDate
                                    ?
                                    <span className="fs-12">
                                        <span className="fs-12 fw-bold text-dark me-1">Start:</span>
                                        {getFormattedDateDDMMYYYY(modalData?.startDate)} -
                                        <span className="fs-12 fw-bold text-dark me-1 ms-1">End:</span>
                                        {getFormattedDateDDMMYYYY(modalData?.endDate)}
                                    </span>
                                    : <></>
                            }

                        </p>

                    </div>
                    <div className="preview-content">
                        {renderBasiInfo()}
                        {renderMembersInfo()}
                    </div>
                </div>
                {/* <div className="d-flex align-items-center justify-content-center bg-dark position-static w-100 bottom-0">
                        {renderFooter()}
                </div> */}
            </div>
            {/* /Preview */}
            {/* Update List */}
            <div className="modal fade" id="modify_item" style={{ zIndex: 100000 }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Update List</h4>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <form >
                            <div className="modal-body">
                                <div className="mb-0">
                                    <label className="form-label">Select Items</label>
                                    <CommonSelectV2
                                        isMulti
                                        options={[]}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <FormFooter />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* / Update List */}
        </>

    );
};

export default AcademicNodeDataModal;